
import { Component, Prop, Vue } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import PlaceList from "./PlaceList.vue";

@Component({
  components: {
    PlaceList,
    RouterLink,
    PlaceHolderCircles: () =>
      import("~/components/molecules/display/PlaceHolderCircles.vue"),
  },
})
export default class PlaceListSection extends Vue {
  @Prop() title: string;
  @Prop() items: Array<{
    name: string;
    link?: { title: string; path: string };
  }>;
  @Prop() exceeded: boolean;
}
